<template>
  <v-container fluid class="px-3 py-0">
    <div class="text-center mb-1">
      <img :src="$store.state.unidad.logo" alt="Logo" class="home-logo" />
    </div>
    <Ranking2
      v-if="is_estado_admin()"
      @loaded-top3="onTop3Loaded"
    />
    <v-row>

      <!-- Ranking -->
      <v-col cols="12" md="6" class="mt-0 pt-0">

        <Ranking3
          ref="ranking3Ref"
          v-if="is_estado_admin()"
        />
        <Ranking v-else />
      </v-col>

      <!-- Info institucional -->
      <v-col cols="12" md="6" class="mt-0 pt-0">

        <!-- Logo -->
        <!-- <div class="text-center mb-4">
          <img :src="$store.state.unidad.logo" alt="Logo" class="home-logo" />
        </div> -->

        <!-- Misión -->
        <v-card outlined class="mb-3">
          <div class="home-section-header">
            <v-icon small color="white" class="mr-2">mdi-flag-outline</v-icon>
            <span class="white--text caption font-weight-bold letter-spacing">NUESTRA MISIÓN</span>
          </div>
          <v-card-text class="body-2 grey--text text--darken-2 py-3">
            {{ $store.state.unidad.mision }}
          </v-card-text>
        </v-card>

        <!-- Visión -->
        <v-card outlined class="mb-3">
          <div class="home-section-header">
            <v-icon small color="white" class="mr-2">mdi-eye-outline</v-icon>
            <span class="white--text caption font-weight-bold">NUESTRA VISIÓN</span>
          </div>
          <v-card-text class="body-2 grey--text text--darken-2 py-3">
            {{ $store.state.unidad.vision }}
          </v-card-text>
        </v-card>

        <!-- Valores -->
        <v-card outlined>
          <div class="home-section-header">
            <v-icon small color="white" class="mr-2">mdi-star-circle-outline</v-icon>
            <span class="white--text caption font-weight-bold">NUESTROS VALORES</span>
          </div>
          <v-card-text class="py-3">
            <div class="home-valores-grid">
              <div v-for="(val, i) in valores" :key="i" class="home-valor-item">
                <v-icon x-small :color="val.color" class="mr-1">{{ val.icon }}</v-icon>
                <span class="caption font-weight-medium">{{ val.text }}</span>
              </div>
            </div>
          </v-card-text>
        </v-card>

      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card outlined>
          <div class="home-section-header home-section-header--interest">
            <v-icon small color="white" class="mr-2">mdi-compass-outline</v-icon>
            <span class="white--text caption font-weight-bold"> SITIOS DE INTERES: </span>
          </div>
          <v-card-text class="py-3">
            <div class="home-valores-grid">
              <div v-for="(val, i) in sitios" :key="i" class="home-valor-item">
                <a :href="val.value" target="_blank">
                  <v-icon x-small :color="val.color" class="mr-1">{{ val.icon }}</v-icon>
                  <span class="caption font-weight-medium">{{ val.text }}</span>
                </a>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import Ranking from '@/views/Ranking.vue';
  import Ranking2 from '@/views/Ranking2.vue';
  import Ranking3 from '@/views/Ranking3.vue';

  export default {
    name: 'home',
    components: { Ranking,Ranking2,Ranking3 },
    data() {
      return {
        valores: [
          { text: 'Espíritu de triunfo', icon: 'mdi-lightning-bolt',       color: 'blue darken-4' },
          { text: 'Trabajo en equipo',   icon: 'mdi-account-group',        color: 'blue darken-4' },
          { text: 'Cooperación',         icon: 'mdi-handshake-outline',    color: 'blue darken-4' },
          { text: 'Identidad',           icon: 'mdi-shield-star-outline',  color: 'blue darken-4' },
          { text: 'Responsabilidad',     icon: 'mdi-check-decagram',       color: 'blue darken-4' },
          { text: 'Ética',               icon: 'mdi-scale-balance',        color: 'blue darken-4' },
          { text: 'Respeto',             icon: 'mdi-heart-outline',        color: 'blue darken-4' },
          { text: 'Creatividad',         icon: 'mdi-lightbulb-outline',    color: 'blue darken-4' },
          { text: 'Satisfacción',        icon: 'mdi-emoticon-happy-outline', color: 'blue darken-4' },
          { text: 'Excelencia',          icon: 'mdi-trophy-outline',       color: 'blue darken-4' },
        ],
        sitios: [
          {text:'Sistema Académico ESAM Portal+', value:'https://academico-sedes.esam.edu.bo/', icon: 'mdi-school-outline', color: 'blue darken-4'},
          {text:'Portal de Pruebas', value:'https://webdev.esam.edu.bo/portal/', icon: 'mdi-school-outline', color: 'blue darken-4'},
          {text:'Bolsa de Trabajo y Servicios de Talento Humano', value:'https://esamtalentum.com/', icon: 'mdi-briefcase-outline', color: 'blue darken-4'},
          {text:'Revista cientifica - Scientific Universe ESAM', value:'https://blog.esam.edu.bo/', icon: 'mdi-book-open-page-variant-outline', color: 'blue darken-4'},
          {text:'Biblioteca Virtual', value:'https://esam.edu.bo/biblioteca-virtual/', icon: 'mdi-bookshelf', color: 'blue darken-4'},
          {text:'Calendario Academico', value:'https://esam.edu.bo/calendario-academico/', icon: 'mdi-calendar-month-outline', color: 'blue darken-4'},
          {text:'Plataforma de Webinars', value:'https://esam.edu.bo/webinars/', icon: 'mdi-video-outline', color: 'blue darken-4'},
          {text:'Portal del estudiante', value:'https://estudiantes.esam.edu.bo/', icon: 'mdi-account-box-outline', color: 'blue darken-4'},
          {text:'TH Person', value:'https://thperson.esam.edu.bo/', icon: 'mdi-account-tie-outline', color: 'blue darken-4'},
          {text:'Recursos humanos', value:'https://rrhh.esam.edu.bo/', icon: 'mdi-account-tie-outline', color: 'blue darken-4'},
          {text:'Esam Siglo XX', value:'https://ge-pagos.esam.edu.bo/', icon: 'mdi-account-tie-outline', color: 'blue darken-4'},
          {text:'Sitio Web ESAM', value:'https://esam.edu.bo/', icon: 'mdi-web', color: 'blue darken-4'},
        ]
      };
    },
    watch: {},
    methods: {
      onTop3Loaded(top3) {
        this.$nextTick(() => {
          if (this.$refs.ranking3Ref && typeof this.$refs.ranking3Ref.exportado_setAsesores === 'function') {
            this.$refs.ranking3Ref.exportado_setAsesores(top3);
          }
        });
      },
      is_estado_admin(){
        const unidas = [1,5,10]
        const conves = [9,20]
        const unit = this.$store.state.CARGO.sede.unidad_negocio;
        const univ = this.$store.state.convenio?.id;

        return conves.includes(univ) && unidas.includes(unit)
      }
    },
    mounted() {},
  };
</script>

<style>
.home-logo {
  max-width: 200px;
  max-height: 120px;
  object-fit: contain;
}
.home-section-header {
  display: flex;
  align-items: center;
  padding: 8px 14px;
  border-radius: 4px 4px 0 0;
  background: linear-gradient(135deg, #0d47a1 0%, #1565c0 52%, #1e88e5 100%);
  border-left: 4px solid #08366f;
  border-bottom: 1px solid #0b3d86;
}
.home-section-header--interest {
  border-left-color: #08366f;
}
.home-valores-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 12px;
}
.home-valor-item {
  display: flex;
  align-items: center;
  padding: 5px 8px;
  background: #f5fbff;
  border-radius: 6px;
  border-left: 3px solid #0d47a1;
}
</style>
